document.addEventListener('DOMContentLoaded', function() {
  'use strict';
  var D = String.fromCharCode(36);
  var PM = {
    "1":[51,58,68,78,95,131,193,248,346,559],
    "2":[54,63,78,91,115,168,257,337,483,800],
    "3":[57,68,87,104,134,201,316,419,607,1019],
    "4":[60,73,95,115,152,232,371,496,723,1225],
    "6":[65,82,111,137,185,290,474,640,940,1611],
    "8":[70,90,125,158,215,343,571,776,1149,1976],
    "9":[72,94,133,169,231,371,619,843,1249,2151],
    "12":[79,105,153,197,276,449,756,1031,1536,2659],
    "14":[80,108,157,201,280,456,766,1047,1561,2709],
    "15":[85,116,171,223,315,520,883,1210,1810,3142],
    "16":[87,120,178,231,330,546,926,1269,1899,3317],
    "18":[91,128,191,250,357,593,1009,1383,2074,3701],
    "20":[95,136,204,267,382,638,1089,1499,2247,4086],
    "25":[104,151,234,309,446,750,1286,1771,2663,5046],
    "32":[117,173,274,365,530,900,1549,2140,3226,6190],
    "36":[124,186,296,396,576,983,1696,2344,3624,7157],
    "50":[137,210,337,453,664,1139,1976,2737,4183,8302]
  };
  var SQ = [50,100,200,300,500,1000,2000,3000,5000,10000];
  var AK = [1,2,3,4,6,8,9,12,14,15,16,18,20,25,32,36,50];
  var MG = 0.7125;
  var MAT = {'glossy':1,'matte':1,'holographic':1.3,'glitter':1.3,'clear':1.3,'glow':1.5,'economy':0.7};

  function gSize() {
    var r = document.querySelector('.radio_size:checked');
    var sd=document.querySelector('#sd-size-dropdown');if(sd)return sd.value;return r?r.value:'3';
  }
  function gQty() {
    var r = document.querySelector('.radio_qty:checked');
   var sd=document.querySelector('#sd-qty-dropdown');if(sd)return sd.value;return r?r.value:'100';
  }
  function gCDim() {
    var w = document.querySelector('#size_w');
    var h = document.querySelector('#size_h');
    return {
      w: w ? parseFloat(w.value) || 0 : 0,
      h: h ? parseFloat(h.value) || 0 : 0
    };
  }
  function gCQty() {
    var i = document.querySelector('#custom_qty');
    return i ? parseInt(i.value, 10) || 50 : 50;
  }
  function gMat() {
    var m = document.querySelector('#sd-material-dropdown');if(!m)m=document.querySelector('#properties_material');
    if (!m) return 1;
    var v = m.value.toLowerCase();
    if (MAT[v] !== undefined) return MAT[v];
    for (var k in MAT) {
      if (v.indexOf(k) !== -1) return MAT[k];
    }
    return 1;
  }
  function gMkup() {
    var c = document.querySelector('.sd-pricing-container');
    if (!c) return 1;
    var m = parseFloat(c.getAttribute('data-markup'));
    return isNaN(m) ? 1 : m;
  }

  function lerp(a, b, t) { return a + (b - a) * t; }
  function logT(a, b, v) {
    if (a === b) return 0;
    return (Math.log(v) - Math.log(a)) / (Math.log(b) - Math.log(a));
  }

  function getPrice(area, qty) {
    var ai = -1, aj = -1, qi = -1, qj = -1;
    var i;
    for (i = 0; i < AK.length; i++) {
      if (AK[i] <= area) ai = i;
      if (AK[i] >= area && aj === -1) aj = i;
    }
    for (i = 0; i < SQ.length; i++) {
      if (SQ[i] <= qty) qi = i;
      if (SQ[i] >= qty && qj === -1) qj = i;
    }
    if (ai === -1) ai = 0;
    if (aj === -1) aj = AK.length - 1;
    if (qi === -1) qi = 0;
    if (qj === -1) qj = SQ.length - 1;
    var p00 = PM[String(AK[ai])][qi];
    var p01 = PM[String(AK[ai])][qj];
    var p10 = PM[String(AK[aj])][qi];
    var p11 = PM[String(AK[aj])][qj];
    var at = (AK[ai] === AK[aj]) ? 0 : logT(AK[ai], AK[aj], area);
    var qt = (qi === qj) ? 0 : logT(SQ[qi], SQ[qj], qty);
    return lerp(lerp(p00, p01, qt), lerp(p10, p11, qt), at);
  }

  function updateAllPrices() {
    var size = gSize();
    var qty = gQty();
    var mat = gMat();
    var mkup = gMkup();
    var area, actualQty;

    if (size === 'custom') {
      var dims = gCDim();
      area = dims.w * dims.h;
      if (area <= 0) area = 9;
    } else {
      var s = parseInt(size, 10);
      area = s * s;
    }

    if (qty === 'custom') {
      actualQty = gCQty();
    } else {
      actualQty = parseInt(qty, 10);
    }
    if (actualQty <= 0) actualQty = 50;

    var raw = getPrice(area, actualQty);
    var total = Math.ceil(raw * MG * mat * mkup);
    var perUnit = total / actualQty;

    var totalStr = D + total;
    var perUnitStr = D + perUnit.toFixed(2);

    // Update total price displays
    var displaySelectors = ['.final_price_display', '.total-price', '#total_price_display'];
    for (var i = 0; i < displaySelectors.length; i++) {
      var el = document.querySelector(displaySelectors[i]);
      if (el) el.textContent = totalStr;
    }

    // Update per-unit price display
    var ppuEl = document.querySelector('.sd-per-unit-display');
    if (ppuEl) ppuEl.textContent = perUnitStr;

    // Update hidden inputs
    var fp = document.querySelector('#final_price');
    if (fp) fp.value = total;
    var fcp = document.querySelector('#final_custom_price');
    if (fcp) fcp.value = total;
    var cqp = document.querySelector('#custom_qty_price');
    if (cqp) cqp.value = total;

    // Update properties
    var ps = document.querySelector('#properties_size');
    if (ps) {
      if (size === 'custom') {
        var d = gCDim();
        ps.value = d.w + 'x' + d.h;
      } else {
        ps.value = size + 'x' + size;
      }
    }
    var pq = document.querySelector('#properties_qty');
    if (pq) pq.value = actualQty;
  }

  // Attach event listeners
  var radios = document.querySelectorAll('.radio_size, .radio_qty');
  for (var i = 0; i < radios.length; i++) {
    radios[i].addEventListener('change', updateAllPrices);
  }
  var inputIds = ['#size_w', '#size_h', '#custom_qty'];
  for (var j = 0; j < inputIds.length; j++) {
    var inp = document.querySelector(inputIds[j]);
    if (inp) {
      inp.addEventListener('change', updateAllPrices);
      inp.addEventListener('input', updateAllPrices);
    }
  }
  var matDd = document.querySelector('#sd-material-dropdown');var sizeDd=document.querySelector('#sd-size-dropdown');if(sizeDd)sizeDd.addEventListener('change',updateAllPrices);var qtyDd=document.querySelector('#sd-qty-dropdown');if(qtyDd)qtyDd.addEventListener('change',updateAllPrices);
  if (matDd) matDd.addEventListener('change', updateAllPrices);

  // Run initial calculation
  updateAllPrices();

  // Run again after a brief delay to catch any late initialization
  setTimeout(updateAllPrices, 100);
  setTimeout(updateAllPrices, 300);

  // Make globally available
  window.updateAllPrices = updateAllPrices;
});
